const colors = ['gray', 'gray-light', 'indigo', 'indigo-light', 'blue', 'yellow', 'red', 'red-light', 'green'] as const;

export type Color = (typeof colors)[number];

export const calculateColor = (input: string): Color => {
	const blacklistedColors = ['indigo-light', 'red-light', 'gray-light'];

	const value = input.split('').reduce((carry, char) => (carry += char.charCodeAt(0)), 0);
	const filteredColors = colors.filter((color) => !blacklistedColors.includes(color));

	return filteredColors[value % filteredColors.length];
};

export const getInitials = (name: string): string => {
	return name
		.trim()
		.split(/\s+/)
		.map((part) => part.charAt(0).toUpperCase())
		.join('')
		.slice(0, 2);
};
